module.exports = __webpack_public_path__ + "static/media/img_jackpot_egt_web_bgjpdetails.b726be9f.jpg";